import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AuthControllerLoginData, AuthControllerLoginResponse, UserControllerMeResponse } from '~/api';
import { authControllerLogin, userControllerMe } from '~/api';
import { getErrorMessage } from '~/utils/api';

export const signIn = createAsyncThunk<
  UserControllerMeResponse | AuthControllerLoginResponse['data'],
  AuthControllerLoginData['body'],
  { rejectValue: string }
>('admin/signIn', async (data, { rejectWithValue }) => {
  try {
    const loginResponse = await authControllerLogin({ body: data });

    if (loginResponse.error) {
      return rejectWithValue(getErrorMessage(loginResponse.error));
    }

    if (!loginResponse.data?.success) {
      return rejectWithValue('general.generalErrorMsg');
    }

    if (loginResponse.data.data.type === 'success') {
      const meRes = await userControllerMe();

      if (meRes.error) {
        return rejectWithValue(getErrorMessage(meRes));
      }

      return meRes.data;
    }

    return loginResponse.data.data;
  } catch (e) {
    return rejectWithValue(getErrorMessage(e));
  }
});
